import { Plus } from 'lucide-react'
export function Brand({ inverse = false }: { inverse?: boolean }) {
  return (
    <div className={`brand ${inverse ? 'brand-inverse' : ''}`}>
      <span className="brand-mark">
        <Plus aria-hidden="true" strokeWidth={3} />
      </span>
      <div>
        <strong>
          Pare<span className="brand-dot">.</span>
        </strong>
        <span className="brand-caption">PHARMACY</span>
      </div>
    </div>
  )
}
